export class headerHeight {

	static isEventsPage() {
		return !!document.querySelector('.event-content');
	}

	static setEventspageHeader() {
		this.header = document.querySelector('.event-content__header');
		this.meta = document.querySelector('.event-content__meta');
		this.innerMeta = document.querySelector('.event-content__meta__inner');
		this.ctaWrapper = document.querySelector('.event-content__cta-wrapper');

		// Breakpoint is based on $breakpoint--medium CSS variable
		if (window.innerWidth < 641) {
			const paddingTop = parseInt(window.getComputedStyle(this.meta, null).getPropertyValue('padding-top'));
			const metaInnerHeight = this.innerMeta.clientHeight;
			const ctaWrapperHeight = this.ctaWrapper.clientHeight;
			this.mobileDifference = paddingTop + metaInnerHeight - ctaWrapperHeight;
		} else {
			this.mobileDifference = 0;
		}
		return this.header.clientHeight - this.mobileDifference;
	}

	static setSiteHeaderHeight() {
		const siteHeader = document.querySelector('.main-navigation');
		if(siteHeader) return siteHeader.scrollHeight;
	}

	static setEventsPageHeaderHeight() {
		if (this.isEventsPage()) {
			return this.setEventspageHeader();
		} else {
			return 0;
		}
	}
}

